module.exports = __webpack_public_path__ + "img/xiangshang.258d810f.png";